<style src="./ContextDynamicLab.scss" lang="scss"></style>
<template>
  <section class="context-dynamic-lab">
    <form @submit.prevent="openModalConfirm" class="context-content">
      <span class="filtertitle">Aplicar Valores</span>
      <div class="options">
        <div class="description">
          Escolher automáticamente as marcas da coluna <strong>CUSTO</strong>
        </div>
        <div class="cont">
          <button
            type="button"
            class="cp1-small-button cp1-button__warning filterbutton"
            @click="autoChooseByCost">
            Aplicar
          </button>
        </div>
      </div>
      <div class="options">
        <span class="description">
          Escolher automáticamente as marcas de forma <strong>ALEATÓRIA</strong>
        </span>
        <div class="cont">
          <button
            type="button"
            @click="autoChooseByRandom"
            class="cp1-small-button cp1-button__warning filterbutton">
            Aplicar
          </button>
        </div>
      </div>
    </form>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmAddSale"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />

        <div class="description">
          <p class="info">
            Essa ação irá inserir as <strong>MARCAS</strong> especificadas.
          </p>
          <p class="info">
            Tem certeza que deseja continuar?
          </p>
        </div>

        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applyValue"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'

export default {
  name: 'ContextDynamicLab',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  props: {
    columnId: null
  },
  data: () => ({
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddSale')
    },
    openModalConfirm () {
      this.$modal.show('modalConfirmAddSale')
    },
    async autoChooseByCost () {
      const labs = this.$store.getters['ItemPricing/FILTERED_LIST'].map(row => {
        return {
          column: this.columnId,
          quoteId: row.itemId,
          value: row.quoted.lab,
          itemId: row.quoted.itemId
        }
      })
      try {
        await this.$store.dispatch('ItemPricing/UPDATE_DYNAMIC_LABS', labs)
        this.$store.commit('ItemPricing/UPDATE_DYNAMIC_LABS', labs)
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddSale')
        this.$emit('close')
      }
    },
    async autoChooseByRandom () {
      const labs = this.$store.getters['ItemPricing/FILTERED_LIST'].map(row => {
        return {
          column: this.columnId,
          quoteId: row.itemId,
          itemId: row.quoted.itemId
        }
      })
      try {
        const randomLabs = await this.$store.dispatch('ItemPricing/UPDATE_DYNAMIC_RANDOM_LABS', labs)
        this.$store.commit('ItemPricing/UPDATE_DYNAMIC_LABS', randomLabs)
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
        this.$modal.hide('modalConfirmAddSale')
        this.$emit('close')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-dynamic-lab/ContextDynamicLab.vue